module.exports = __webpack_public_path__ + "img/banner.12f53865.png";